module.exports = __webpack_public_path__ + "img/clound_3.9181d5c3.png";